import {
  CircularProgress,
  FormControlLabel,
  Switch,
  withWidth,
} from "@material-ui/core";
import React from "react";
import { createConfirmation } from "react-confirm";
import confirmable from "react-confirm/lib/confirmable";
import PropTypes from "prop-types";
import CloseIcon from "@material-ui/icons/Close";
import { Modal, ModalBody } from "reactstrap";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import CategoryService from "../../../Services/Category/CategoryService";
import WYSIWYGEditor from "../../../components/InputTextareaEditor/WYSIWYG";

import boldIcon from "../../../assets/icons/toolbar/bold.svg";
import italicIcon from "../../../assets/icons/toolbar/italic.svg";
import underlineIcon from "../../../assets/icons/toolbar/underline.svg";
import alignLeftIcon from "../../../assets/icons/toolbar/align-left.svg";
import alignCenterIcon from "../../../assets/icons/toolbar/align-center.svg";
import alignRightIcon from "../../../assets/icons/toolbar/align-right.svg";
import alignJustifyIcon from "../../../assets/icons/toolbar/align-justify.svg";
import listBulletedIcon from "../../../assets/icons/toolbar/list-bulleted.svg";
import listNumberedIcon from "../../../assets/icons/toolbar/list-numbered.svg";
import { css, cx } from "emotion";
import SelectSearchBootstrap from "../../../components/InputSelectSearch/SelectSearchBootstrap";
import MaskedInput from "react-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import { formatDB } from "../../../components/Utils/Currency";
import ImageUploader from "../../../components/ImageUploader";
import ProductStore from "../../../Store/ProductStore";
import { useState } from "react";
import { useEffect } from "react";

import ProductService from "../../../Services/ProductService/ProductService";
import TenantService from "../../../Services/TenantService/TenantService";
import propertyStore from "../../../Store/PropertyStore";
import EditorialService from "../../../Services/EditorialService/EditorialService";
import {
  SelectValidator,
  TextValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";

// import ProductService from "../../../Services/ProductService/ProductService";

const user = JSON.parse(localStorage.getItem("user")) || "";
const NewForm = (props) => {
  const maxPhoto = 5;
  const { width, data, cancel, title } = props;
  console.log(data);
  const [productState, productActions] = ProductStore();
  const [state, setState] = React.useState({
    formData: {
      id: "",
      name: "",
      product_code: "",
      description: "",
      price: "",
      discounted_price: "",
      stock: "",
      max_qty: "",
      category: "",
      tenant: JSON.parse(localStorage.getItem("user")).tenant,
      image_urls: [],
      main_image: "",
      weight: "",
      dimension_length: "",
      dimension_width: "",
      dimension_height: "",
    },
  });
  const [loading, setLoading] = React.useState(false);
  const [optionsCategory, setOptionsCategory] = React.useState([]);
  const [optionsCategoryShopFront, setOptionsCategoryShopFront] =
    React.useState([]);
  const [discount, setDiscount] = React.useState(false);
  const [openDialog, setOpenDialog] = React.useState(true);

  const refDescription = React.createRef();
  const refCategory = React.createRef();
  const refCategoryShopfront = React.createRef();

  const numberMask = (allowDecimal) => {
    return createNumberMask({
      prefix: "",
      sufix: "",
      includeThousandsSeparator: true,
      thousandsSeparatorSymbol: ".",
      allowDecimal: allowDecimal,
      decimalSymbol: ",",
    });
  };

  const handleToggle = () => {
    setState({
      formData: {
        id: "",
        name: "",
        product_code: "",
        description: "",
        price: "",
        discounted_price: "",
        stock: "",
        category: "",
        shopfront: "",
        tenant: JSON.parse(localStorage.getItem("user")).tenant,
        image_urls: [],
        main_image: "",
        weight: "",
        dimension_length: "",
        dimension_width: "",
        dimension_height: "",
      },
    });
    setOpenDialog(!openDialog);
  };

  const remapImageUrls = (data) => {
    if (data.length < maxPhoto) {
      for (let index = data.length + 1; index <= maxPhoto; index++) {
        data[index] = "";
      }
    }

    return data?.map((value, index) => {
      return {
        image: value,
      };
    });
  };

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors, isValid },
    control,
    watch,
    reset,
  } = useForm({
    mode: "all",
    reValidateMode: "onChange",
    shouldUnregister: false,
  });
  const { fields, append, prepend, remove, swap, move, insert } = useFieldArray(
    {
      control,
      name: "image_urls",
    }
  );

  const watchFields = watch();

  const onSubmit = async (e) => {
    e.preventDefault();
    console.log(selectedOption);
    console.log("lontong");

    let obj = {
      product: {
        id: selectedOption[0].value,
      },
      type: {
        id: selectedOption[0].type,
      },
    };
    try {
      const res = productActions.storeCurrated(obj);
      console.log(res);
      handleToggle();
      cancel();
    } catch (error) {
      console.log(error);
    }
    // const { formData } = state;
    // // console.log(data);
    // let image_urls = data.image_urls.map((value) => {
    //   return value["image"];
    // });
    // image_urls = image_urls.filter((value) => {
    //   return value;
    // });
    // const params = {
    //   id: formData?.id,
    //   name: data.name,
    //   product_code: data.product_code,
    //   description: data.description,
    //   price: formatDB(data.price),
    //   discounted_price: formatDB(data.discounted_price || 0),
    //   stock: formatDB(data.stock),
    //   max_qty: formatDB(data.max_qty),
    //   shopfront: { id: data.shopfront },
    //   master_category: { id: data.category },
    //   tenant: JSON.parse(localStorage.getItem("user")).tenant,
    //   image_urls: image_urls,
    //   main_image: data.main_image || data.image_urls[0],
    //   weight: formatDB(data.weight),
    //   dimension_length:
    //     data.dimension_length !== "" ? formatDB(data.dimension_length) : 0,
    //   dimension_width:
    //     data.dimension_width !== "" ? formatDB(data.dimension_length) : 0,
    //   dimension_height:
    //     data.dimension_height !== "" ? formatDB(data.dimension_length) : 0,
    // };
    // console.log(params);
    // console.log("<<<<s");
    // if (props.data === null) {
    //   productActions
    //     .store(params)
    //     .then(() => {
    //       handleToggle();
    //       cancel();
    //     })
    //     .catch(() => {
    //       handleToggle();
    //       cancel();
    //     });
    // } else {
    //   productActions
    //     .put(params.id, params)
    //     .then(() => {
    //       handleToggle();
    //       cancel();
    //     })
    //     .catch(() => {
    //       handleToggle();
    //       cancel();
    //     });
    // }
  };

  const pushProductImage = (value, key) => {
    const { formData } = state;
    formData["image_urls"][key] = value;
    setValue(`image_urls[${key}]`, {
      image: value,
    });
    setState({ formData });
  };

  const removeProductImage = (key) => {
    const { formData } = state;
    formData["image_urls"][key] = "";
    setValue(`image_urls[${key}]`, {
      image: "",
    });
    setState({ formData });
  };

  const asyncGetOptionsCategory = (query) => {
    return new Promise((resolve, reject) => {
      CategoryService.getDataShopfront({
        type: "product",
        tenant_id:
          user?.type === "tenant"
            ? user?.tenant?.id
            : state.formData.tenant
            ? state.formData.tenant
            : 0,
        keyword: query,
        cursor: "",
      })
        .then((response) => {
          const listOptions = response.data.map((row) => ({
            value: row.id,
            name: row.name,
          }));
          setOptionsCategory(listOptions);
          resolve(listOptions);
        })
        .catch(reject);
    });
  };

  const asyncGetOptionsCategoryShopfront = (query) => {
    return new Promise((resolve, reject) => {
      CategoryService.getData({
        type: "product",
        tenant_id:
          user?.type === "tenant"
            ? user?.tenant?.id
            : state.formData.tenant
            ? state.formData.tenant
            : 0,
        keyword: query,
        cursor: "",
      })
        .then((response) => {
          const listOptions = response.data.map((row) => ({
            value: row.id,
            name: row.name,
          }));
          setOptionsCategoryShopFront(listOptions);
          resolve(listOptions);
        })
        .catch(reject);
    });
  };

  const loadRelationData = () => {
    setLoading(true);

    const categoryName = data ? data?.category?.name : "";
    Promise.all([asyncGetOptionsCategory(categoryName)]).then(() => {
      setLoading(false);
    });
    const categoryNameShopfront = data ? data?.category?.name : "";
    Promise.all([asyncGetOptionsCategoryShopfront(categoryNameShopfront)]).then(
      () => {
        setLoading(false);
      }
    );
  };

  React.useEffect(() => {
    loadRelationData();
    if (data) {
      const formData = {
        id: data?.id || "",
        name: data?.name || "",
        product_code: data?.product_code || "",
        price: data?.price?.value?.toString() || "",
        discounted_price: data?.discounted_price || "",
        stock: data?.stock || "",
        max_qty: data?.max_qty || "",
        category: data?.product_type_id || "",
        shopfront: data?.category?.id || "",
        tenant: JSON.parse(localStorage.getItem("user")).tenant,
        description: data?.description || "",
        image_urls: data?.image_urls ? data?.image_urls : [],
        main_image: data?.main_image
          ? data?.main_image
          : data?.image_urls[0] || "",
        weight: data?.weight || "",
        dimension_length: data?.dimension?.length || "",
        dimension_width: data?.dimension?.width || "",
        dimension_height: data?.dimension?.height || "",
      };
      setState({ formData });
      if (data.discounted_price > 0) {
        setDiscount(true);
      }

      reset({
        id: data?.id || "",
        name: data?.name || "",
        product_code: data?.product_code || "",
        price: data?.price?.value?.toString() || "",
        discounted_price: data?.discounted_price || "",
        stock: data?.stock || "",
        max_qty: data?.max_qty || "",
        category: data?.product_type_id || "",
        shopfront: data?.category?.id || "",
        tenant: JSON.parse(localStorage.getItem("user")).tenant,
        description: data?.description || "",
        image_urls: data?.image_urls ? remapImageUrls(data?.image_urls) : [],
        main_image: data?.main_image
          ? data?.main_image
          : data?.image_urls[0] || "",
        weight: data?.weight || "",
        dimension_length: data?.dimension?.length || "",
        dimension_width: data?.dimension?.width || "",
        dimension_height: data?.dimension?.height || "",
      });
    } else {
      reset(state?.formData);
    }
  }, [data]);
  // const { classes } = props;

  const [isHighLight, setisHighLight] = useState(false);
  const [buttonAddProduct, setbuttonAddProduct] = useState(true);

  // SEARCH BRAND
  const [optionBrand, setoptionBrand] = useState([]);
  const [selectedBrand, setselectedBrand] = useState({
    id: "",
    name: "Choose Brand",
  });
  const [insearchBrand, setinsearchBrand] = useState("");
  const [openSelectBrand, setopenSelectBrand] = useState(false);
  const getBrand = async (id) => {
    const res = await TenantService.getData({
      num: 100,
      property: id,
      cursor: "",
    });
    let newRes = [];
    res.data.map((item) => {
      let obj = { value: item.id, label: item.name, logo: item.logo.square };
      newRes.push(obj);
    });
    // console.log(newRes);
    setoptionBrand(newRes);
  };
  // console.log(optionBrand);

  // useEffect(() => {
  //   getBrand();
  // }, []);
  const handleChangeSelectBrand = (value) => {
    // console.log(value);
    setselectedBrand({
      id: value.value,
      name: value.label,
      // logo: value.logo.square,
    });
  };
  // console.log(selectedBrand);

  const loadoptionBrand = async (e) => {
    setinsearchBrand(e.target.value);
    // console.log(e.target.value);
    const res = await TenantService.getData({
      num: 100,
      property: selectProperty.id,
      cursor: "",
      keyword: e.target.value,
    });
    // console.log(res.data);
    let newRes = [];
    res.data.map((item) => {
      let obj = { value: item.id, label: item.name, logo: item.logo.square };
      newRes.push(obj);
    });
    // console.log(newRes);
    setoptionBrand(newRes);
  };
  // END SEARCH BRAND

  // SEARCH PRODUCT
  const [optionProduct, setoptionProduct] = useState([]);
  const [selectedOption, setSelectedOption] = useState([]);
  const [insearch, setinsearch] = useState("");
  const [openSelect, setopenSelect] = useState(false);
  const getProduct = async (id) => {
    const res = await ProductService.getData({
      tenant_id: id,
      property_id: 0,
      page: 1,
      perPage: 100,
    });
    let newRes = [];
    res.data.map((item) => {
      let obj = {
        value: item.id,
        label: item.name,
        logo: item.main_image,
        type: item.tenant.tenant_type.id,
      };
      newRes.push(obj);
    });
    // console.log(newRes);
    setoptionProduct(newRes);
  };
  // console.log(optionProduct);
  // useEffect(() => {
  //   getProduct();
  // }, []);
  const handleChangeSelect = (value) => {
    console.log(value);
    const cek = selectedOption.includes(value);
    console.log(cek);
    if (!cek) {
      setbuttonAddProduct(true);
      // setSelectedOption([...selectedOption, value]);
      setSelectedOption([value]);
    }
    // setselectProperty([]);
    // setselectedBrand([]);
    // setselectTenant([]);
  };

  // console.log(selectedOption);
  // console.log(optionBrand);
  // console.log("+======");
  const loadoption = async (e) => {
    setinsearch(e.target.value);
    // console.log(e.target.value);
    const res = await ProductService.getData({
      tenant_id: +selectedBrand.id,
      property_id: 0,
      page: 1,
      perPage: 100,
      keyword: e.target.value,
    });
    // console.log(res.data);
    let newRes = [];
    res.data.map((item) => {
      let obj = {
        value: item.id,
        label: item.name,
        logo: item.main_image,
        type: item.tenant.tenant_type.id,
      };
      newRes.push(obj);
    });
    // console.log(newRes);
    setoptionProduct(newRes);
  };
  // END SEARCH PRODUCT

  //START SELECT PROPERTY
  const [propertyState, propertyActions] = propertyStore();
  let perPage = 10;
  const [selectProperty, setselectProperty] = useState({
    id: "",
    name: "Choose Mall",
  });
  const [openoptionProperty, setopenoptionProperty] = useState(false);
  const [insearchProperty, setinsearchProperty] = useState("");

  const loadoptionProperty = (e) => {
    const refresh = true;
    const propertyType = "";
    setinsearchProperty(e.target.value);
    var query = {
      num: perPage.toString(),
      operational_level: user?.operational?.level,
      level: user?.operational?.level < 3 ? user?.operational?.level - 1 : "",
      type: propertyType || "",
      parent_id: user?.operational?.level < 3 ? user?.operational?.id : "",
      cursor: refresh ? "" : propertyState.header["x-cursor"] || "",
      keyword: e.target.value,
    };
    propertyActions.getList(query, refresh);
  };
  const loadoptionProperty2 = (e) => {
    const refresh = true;
    const propertyType = "";
    var query = {
      num: perPage.toString(),
      operational_level: user?.operational?.level,
      level: user?.operational?.level < 3 ? user?.operational?.level - 1 : "",
      type: propertyType || "",
      parent_id: user?.operational?.level < 3 ? user?.operational?.id : "",
      cursor: refresh ? "" : propertyState.header["x-cursor"] || "",
    };
    propertyActions.getList(query, refresh);
  };
  useEffect(() => {
    loadoptionProperty2();
  }, []);
  // console.log(selectProperty);
  // END SELECT PROPERTY

  //START SELECT TENANT
  const [dataTenant, setdataTenant] = useState([]);
  const [selectTenant, setselectTenant] = useState({
    id: "",
    name: "Choose Tenant",
  });

  const handleGetTenantList = async (id) => {
    var query = {
      num: 100,
      property: id,
      cursor: "",
    };

    const res = await TenantService.getData(query);
    // console.log(res);
    setdataTenant(res);
    // console.log("++++");
  };
  // END SELECT TENANT
  const [errorHighlight, seterrorHighlight] = useState("limit highlight");
  const handleChangeHighlight = async (e) => {
    // console.log(e.target.value);
    // console.log(data.id);
    try {
      const res = await EditorialService.cekHighlight();
      if (isHighLight === false) {
        setisHighLight(true);
      }
      if (isHighLight === true) {
        setisHighLight(false);
      }
    } catch (error) {
      console.log("masuk sini");
      if (isHighLight === true) {
        setisHighLight(false);
      }
    }
  };

  return (
    <Modal
      isOpen={openDialog}
      toggle={handleToggle}
      backdrop={false}
      centered={true}
      size="lg"
      zIndex={1300}
      modalClassName={css`
        max-height: 100%;
        overflow-y: scroll !important;
        background: rgba(0, 0, 0, 0.7);
      `}
      contentClassName={css`
        background: none !important;
        border: none !important;
      `}
    >
      {loading && (
        <ModalBody>
          <div className="card border-0 rounded-8px">
            <div className="card-body p-4">
              <div className="w-100 d-flex flex-column justify-content-center align-items-center">
                <CircularProgress />
                <span className="font-16 text-muted mt-3">
                  Preparing form ...
                </span>
              </div>
            </div>
          </div>
        </ModalBody>
      )}
      {!loading && (
        <ModalBody>
          <div className="card border-0 rounded-8px">
            <div
              className="card-header bg-white p-4 border-bottom-1-secondary"
              style={{ borderRadius: 8 }}
            >
              <div className="d-flex w-100 justify-content-between align-items-center">
                <h2 className="font-bold font-20 text-uppercase">
                  {title || "Product"}
                </h2>
                <span onClick={handleToggle} className="cursor-pointer">
                  <CloseIcon />
                </span>
              </div>
            </div>
            <ValidatorForm
              id="myform"
              // onSubmit={(e) => {
              //   handleSubmit(e);
              // }}
            >
              <div className="card-body p-4">
                <h3 className="font-bold font-16 text-blue mb-4">
                  Select Product
                </h3>
                {/* <label className="mt-3">Select Product</label> */}
                {selectedOption.map((e, index2) => {
                  return (
                    <div
                      class="alert alert-info d-flex justify-content-between align-items-center"
                      role="alert"
                    >
                      <img
                        src={e.logo}
                        style={{
                          width: "2rem",
                          height: "2rem",
                          marginRight: "1rem",
                        }}
                        alt=""
                      />
                      <div>{e.label}</div>
                      <div
                        onClick={() => {
                          // console.log(e.value);
                          const newselected = selectedOption.filter(
                            (item, index) => {
                              // console.log(item.value);
                              if (index2 !== index) {
                                return item;
                              }
                            }
                          );
                          setSelectedOption(newselected);
                          // console.log(newselected);
                          // console.log(",<<<<<,");
                        }}
                      >
                        <div className="cursor-pointer">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            fill="currentColor"
                            class="bi bi-trash3"
                            viewBox="0 0 16 16"
                          >
                            <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  );
                })}
                {/* {buttonAddProduct ? (
                  <>
                    <button
                      type="button"
                      onClick={() => {
                        setbuttonAddProduct(false);
                      }}
                      class="btn btn-primary btn-lg btn-block"
                    >
                      Add Product
                    </button>
                  </>
                ) : ( */}
                <>
                  {/* DROPDOWN PROPERTY */}
                  <div class="dropdown">
                    <TextValidator
                      // id="search"
                      label="Search property..."
                      name="search"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      // className={classes.textField}
                      // margin="normal"
                      variant="outlined"
                      value={insearchProperty}
                      type="text"
                      inputProps={{ maxLength: 61 }}
                      style={{ width: "100%" }}
                      // validators={["required", "maxStringLength:60"]}
                      // errorMessages={[
                      //   "Title is required",
                      //   "maximum character is 60",
                      // ]}
                      onChange={loadoptionProperty}
                      autoComplete="off"
                      autoFocus
                    />

                    <div
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuButton"
                    >
                      {propertyState.data.map((e) => {
                        // console.log(e);
                        return (
                          <>
                            <button
                              onClick={() => {
                                setselectProperty({ id: e.id, name: e.name });
                                handleGetTenantList(e.id);
                                getBrand(e.id);
                                setinsearchProperty(e.name);
                                setinsearchBrand("");
                                setinsearch("");
                              }}
                              class="dropdown-item"
                            >
                              {e.name}
                            </button>
                          </>
                        );
                      })}
                    </div>
                    {/* </> */}
                    {/* ) : null} */}
                  </div>
                  {/* END DROPDOWN PROPERTY */}

                  {/* SEARCH BRAND */}
                  {optionBrand && optionBrand.length > 0 ? (
                    <>
                      {/* <div className="position-relative"> */}
                      <div class="dropdown mt-3 mb-3">
                        <TextValidator
                          // id="search"
                          label="Search brand..."
                          name="search"
                          // className={classes.textField}
                          // margin="normal"
                          variant="outlined"
                          value={insearchBrand}
                          type="text"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          inputProps={{ maxLength: 61 }}
                          style={{ width: "100%" }}
                          // validators={["required", "maxStringLength:60"]}
                          // errorMessages={[
                          //   "Title is required",
                          //   "maximum character is 60",
                          // ]}
                          onChange={loadoptionBrand}
                          autoComplete="off"
                          autoFocus
                        />

                        <div
                          className="dropdown-menu overflow-auto"
                          aria-labelledby="dropdownMenuButton"
                          style={{ width: "100%", height: "200px" }}
                        >
                          {/* <div className="position-relative bg-white opacity-100"> */}
                          {optionBrand.map((e) => {
                            return (
                              <div>
                                <button
                                  class="dropdown-item"
                                  onClick={() => {
                                    setinsearchBrand(e.label);
                                    handleChangeSelectBrand(e);
                                    setopenSelectBrand(false);
                                    getProduct(e.value);
                                    setinsearch("");
                                  }}
                                >
                                  <img
                                    src={e.logo}
                                    style={{
                                      width: "2rem",
                                      height: "2rem",
                                      marginRight: "1rem",
                                    }}
                                    alt=""
                                  />
                                  {e.label}
                                </button>
                              </div>
                            );
                          })}
                          {/* </div> */}
                        </div>
                      </div>
                      {/* ) : null} */}
                      {/* </div> */}
                    </>
                  ) : null}
                  {/* END SEARCH BRAND */}
                  {/* SEARCH PRODUCT */}
                  {optionProduct && optionProduct.length > 0 ? (
                    <>
                      <div className="dropdown">
                        {/* <div class="input-group mb-3"> */}
                        <TextValidator
                          // id="search"
                          label="Search product..."
                          name="search"
                          // className={classes.textField}
                          // margin="normal"
                          variant="outlined"
                          value={insearch}
                          type="text"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          inputProps={{ maxLength: 61 }}
                          style={{ width: "100%" }}
                          // validators={["required", "maxStringLength:60"]}
                          // errorMessages={[
                          //   "Title is required",
                          //   "maximum character is 60",
                          // ]}
                          onChange={loadoption}
                          autoComplete="off"
                          autoFocus
                        />

                        <>
                          <div
                            className="dropdown-menu overflow-auto"
                            aria-labelledby="dropdownMenuButton"
                            style={{ width: "100%", height: "200px" }}
                          >
                            {optionProduct.map((e) => {
                              return (
                                <button
                                  class="dropdown-item"
                                  onClick={() => handleChangeSelect(e)}
                                >
                                  <img
                                    src={e.logo}
                                    style={{
                                      width: "3rem",
                                      height: "3rem",
                                      marginRight: "1rem",
                                    }}
                                    alt=""
                                  />
                                  {e.label}
                                </button>
                              );
                            })}
                          </div>
                        </>
                        {/* ) : null} */}
                      </div>
                    </>
                  ) : null}
                  {/* END SEARCH PRODUCT */}

                  {/* <button
                    type="button"
                    onClick={() => {
                      setbuttonAddProduct(true);
                    }}
                    class="btn btn-danger btn-lg btn-block mt-3"
                  >
                    Cancel
                  </button> */}
                </>
                {/* // )} */}
              </div>
            </ValidatorForm>
          </div>
          <div
            className={cx(
              css`
                background: none !important;
              `,
              "card border-0 rounded-8px mt-3"
            )}
          >
            <div className="card-body py-2 px-0">
              <form onSubmit={onSubmit}>
                {!productState.isSaving && (
                  <div className="form-group text-right">
                    <button
                      type="button"
                      className={cx(
                        css`
                          padding: 14px 32px;
                          color: #bdbdbd !important;
                          background: none !important;
                        `,
                        "btn btn-md border-0 font-12 font-bold mr-3"
                      )}
                      onClick={handleToggle}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className={cx(
                        css`
                          background-color: #bbdefb !important;
                          color: #2196f3 !important;
                          padding: 14px 32px;
                        `,
                        "btn btn-md border-0 font-12 font-bold rounded-8px"
                      )}
                    >
                      {props.data ? "UPDATE" : "CREATE"}
                    </button>
                  </div>
                )}

                {productState.isSaving && (
                  <div className="w-100 d-flex justify-content-end align-items-center">
                    <CircularProgress size="1rem" />{" "}
                    <span className="ml-2 font-bold text-white">Menyimpan</span>
                  </div>
                )}
              </form>
            </div>
          </div>
        </ModalBody>
      )}
    </Modal>
  );
};

NewForm.propTypes = {
  width: PropTypes.oneOf(["lg", "md", "sm", "xl", "xs"]).isRequired,
  cancel: PropTypes.func,
};
export function productForm(title, data, options = {}) {
  return createConfirmation(confirmable(withWidth()(NewForm)))({
    title,
    data,
    ...options,
  });
}
